import React from "react";
import MUiButton from "@mui/material/Button";

export default function Button(props) {
  return (
    <MUiButton
      className={props.className}
      color={props.color}
      style={{ backgroundColor: props.backgroundColor }}
      variant={props.variant ? props.variant : "contained"}
      onClick={props.onClick}
      disabled={props.disabled}
      type={props.type}
      endIcon={props.endIcon}
      startIcon={props.startIcon}
      size={props.size}
      sx={props.sx}
    >
      {props.children}
    </MUiButton>
  );
}
